// Refactor with new validator for v2

import { forEach, camelCase } from 'lodash';

export default function setValidationErrors(errors, aliases = {}) {
  const errorsToReturn = {};

  forEach(errors, (errorList, key) => {
    key = aliases[key] || camelCase(key);

    errorsToReturn[key] = errorList[0];
  });

  return errorsToReturn;
}
